import styled, { css } from 'styled-components';

type BaseItemProps = {
  isSelected: boolean;
};

export const Container = styled.div<BaseItemProps>`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
  min-height: 74px;

  display: flex;
  align-items: center;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: #0b29fb;
      border-width: 2px;
    `}
`;

export const InputWrapper = styled.div`
  width: 74px;
  height: 100%;
  background: #eff0f0;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputSelect = styled.div<BaseItemProps>`
  width: 18px;
  height: 18px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: #00995d;
      border: 1px solid #00995d;
    `}
`;

export const BaseInfoWrapper = styled.div`
  min-width: 50%;
  margin-left: 24px;
  display: flex;
  flex-direction: column;
`;

export const InfosDetailWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  margin-left: 48px;
`;

export const InfoDetailWrapper = styled.div``;

export const TitleInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BaseName = styled.span<BaseItemProps>`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  color: #3d3d3d;
  line-height: 24px;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #0b29fb;
    `}
`;

export const BaseAddress = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;

export const TitleDetail = styled.span<BaseItemProps>`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #0b29fb;
    `}
`;

export const DetailInfo = styled.span<BaseItemProps>`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #0b29fb;
    `}
`;

export const Divisor = styled.div`
  border-right: 2px rgba(218, 218, 218, 0.8) dashed;
  height: 80%;
`;
